import React from "react";
import { Typography } from '@mui/material';
import { Link } from "react-router-dom";
import module from './HistoryBanner.module.css';

export default function HistoryBanner() {
    return (
        <Link to='/mypage/reward/setting' className={module.banner}>
            <Typography sx={{fontSize: "12px", color: "#15B855", fontWeight: "500"}}>お振込口座を今すぐ登録してください。</Typography>

            <div className={module.circle}>
                <span className={module.arrow}></span>
            </div>
        </Link>
    )
}